export const CUSTOMER_FIELDS = `
id
name
phone
email
address
createdAt
`;
